































import Tag, { ITag } from '@/models/Tag'
import { apiV1TagPath } from '@/rails/routes'
import axios from 'axios'
import {Component, Emit, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'

@Component
export default class ChangeJobForm extends VueBase {
  @Prop({ type: Array, default: () => [] }) readonly value!: Array<Tag>

  @Emit()
  input(value: Array<Tag>): Array<Tag> {
    return value
  }

  @Emit()
  onSelect(): void {}
  @Emit()
  onCancel(): void {}

  get internalValue(): Array<Tag> {
    return this.value
  }

  set internalValue(val: Array<Tag>) {
    this.input(val)
  }

  get valueIds(): Array<number> {
    return this.value.map(v => v.id)
  }

  get selectedCategory(): Tag {
    return this.items[this.selectedCategoryIndex] || new Tag()
  }

  items: Array<Tag> = []
  selectedCategoryIndex = 0

  async mounted(): Promise<void> {
    const hopeJobsRoot = await axios.get<ITag>(apiV1TagPath('hope_jobs'))
    this.items = new Tag(hopeJobsRoot.data).children
  }

  changeSelected(category: Tag, checked: boolean): void {
    if (checked) {
      this.internalValue = this.internalValue.concat([category])
    } else {
      this.internalValue = this.internalValue.filter(v => v.id !== category.id)
    }
  }
}
